import React, { Component, useState } from "react"
import { Link } from "gatsby"
import styled from "styled-components";
import Container, { Row, Half, Quarter, ThreeQuarter } from "../../components/layout/container";
import PlanVisit from "../../components/sections/plan-your-visit";

import { GatsbyImage, getImage } from "gatsby-plugin-image"

const StoryList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    h1 {
        font-family: ${(props) => props.theme.fontGreen};
        font-size: 4rem;
        letter-spacing: 0.05rem;
        @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
            display: none;
            font-size: 2rem;
        }
        @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
            display: none;
            font-size: 3rem;
        }
    }
    #id9dbb39f4-d071-5a33-8937-4a9c434dafd3 {
        display: none;
    }
`
const Title = styled.h1`
        display: none;
        @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
            font-family: ${(props) => props.theme.fontGreen};
            font-size: 2rem;
            letter-spacing: 0.05rem;
            margin-bottom: 0;
            display: block;
        }
        @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
            font-family: ${(props) => props.theme.fontGreen};
            font-size: 2rem;
            letter-spacing: 0.05rem;
            margin-bottom: 0;
            display: block;
        }
`

const Story = styled.li`
    padding-bottom: 5rem;
    padding-top: 2rem;
    border-bottom: 3px solid ${props => props.theme.colors.primary};

    &:last-of-type {
        border-bottom: none;
    }
    a {
        text-decoration: none;
    }
    .story-container {
        display: flex;
        @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
            display: block;
        }
        .story-info {
            padding-left: 2rem;
            @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
                padding-left: 0;
                padding-top: 1rem;
            }
            span {
                font-size: 0.8rem;
                text-transform: uppercase;
                font-family: ${(props) => props.theme.fontTurmoil};
                letter-spacing: 1px;
            }
            h3 {
                margin: 0;
                padding-bottom: 1rem;
                text-transform: uppercase;
                font-family: ${(props) => props.theme.fontTurmoil};
                letter-spacing: 0.03rem;
                line-height: 1;
                font-size: 2.5rem;
                @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
                    font-size: 2.25rem;
                }
            }
            p {
                margin-bottom: 3rem;
            }
        }
        .gatsby-image-wrapper {
            width: 250px;
        }
    }
`

const Button = styled(Link)`
  font-size: 1rem;
  padding: 0.8rem 2rem;
  background: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.primary};
  text-decoration: none;
  transition: 0.3s;
  position: relative;
  font-family: ${(props) => props.theme.fontCondensed};
  &:hover {
    background: ${props => props.theme.colors.primary};
    //border: 2px solid ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.white};
  }
  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
    padding: 0.8rem 2rem;
    font-size: 1rem;
  }
`

const Filter = styled.ul`
    position: sticky;
    top: 6rem;
    list-style: none;
    padding: 0.5rem 0;
    margin-top: 9rem;
    @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
        border-top: 1px solid ${props => props.theme.colors.primary};
        border-bottom: 1px solid ${props => props.theme.colors.primary};
        margin-top: 2rem;
    }
    @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
        margin-top: 1rem;
        position: sticky;
    }
    span {
            padding-bottom: 1rem;
            display: block;
            text-transform: uppercase;
            font-family: ${(props) => props.theme.fontTurmoil};
            letter-spacing: 1px;
            font-size: 0.6rem;
            @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
                display: none;
            }
            @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
                display: none;
            }
        }
    li {
        cursor: pointer;
        
        .radio {
            width: 14px;
            height: 14px;
            min-width: 14px;
            min-height: 14px;
            border: 3px solid ${props => props.theme.colors.primary};
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 1rem;
            @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
                margin-right: 0.5rem;
            }
            transition: all 0.1s linear;
            .radio-inner-circle {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: #ffffff;
                transition: all 0.1s linear;
            }
        }
        .category {
            font-size: 1rem;
        }
      display: flex;
      @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
            display: inline-flex;
            margin-right: 1rem;
            border-bottom: none;
        }
      font-family: ${(props) => props.theme.fontBold};
      flex-direction: row;
        padding: 0.5rem 0 0.5rem;
        margin-right: 6rem;
      border-bottom: 3px solid ${props => props.theme.colors.primary};
      &.active {
        background: ${props => props.theme.colors.primary};
        color: #fff;
        span:first-of-type {
          color: ${props => props.theme.colors.primary};
        }
      }
    }
  
`



const activeRadioClass = {
  backgroundColor: "#D33D17",
}

const getCategories = items => {
  let categoryItems = items.map(item => {
    return item.node.category
  })
  let uniqueCategories = new Set(categoryItems)
  let categories = Array.from(uniqueCategories)
  categories = ["All", ...categories]
  return categories
}



class BlogItems extends Component {
    state = {
        items: this.props.items.allContentfulWhatsOn.edges,
        blogPostItems: this.props.items.allContentfulWhatsOn.edges,
        categories: getCategories(this.props.items.allContentfulWhatsOn.edges),
        selectedItem: getCategories(this.props.items.allContentfulWhatsOn.edges) && getCategories(this.props.items.allContentfulWhatsOn.edges)[0],
    }
    handleItems = category => {
        if (category === "All") {
            this.setState({
                blogPostItems: [...this.state.items],
                selectedItem: category,
            })
        } else {
            this.setState({
                blogPostItems: [
                    ...this.state.items.filter(edge => {
                    return edge.node.category === category
                    }),
                ],
            selectedItem: category,
            })
        }
    }
  render() {
      console.log(this.state.categories);
       if (this.state.blogPostItems.featuredImage === null) {
            var featuredImageTrue = false;
        }
        else if (this.state.blogPostItems.featuredImage != null) {
            var featuredImageTrue = true;
        }
    return (
        <React.Fragment>
            <Title>MARKET STORIES</Title>
            <Quarter>
                
                <Filter className="filterButton">
                    <span>Filter Stories</span>
                    {this.state.categories.map((category, index) => {
                        //const [selected, setSelected] = useState("first");
                        return (
  
                        <li key={index} onClick={() => {window.scrollTo({top: 0, behavior: "smooth"}); this.handleItems(category);}} > 
                            <div className="radio" style={this.state.selectedItem === category ? activeRadioClass : null}><div className="radio-inner-circle"></div></div>
                            <div className="category">{category}</div>
                        </li>
        
                        
                        )
                    })}
                </Filter>         
            </Quarter>
            <ThreeQuarter>
                
                <StoryList>
                <h1>MARKET STORIES</h1>
                {this.state.blogPostItems.map((edge) => (
                    
                    <Story className="post" id={'id' + edge.node.id} key={edge.node.id}>
                        <Link to={`/news/${edge.node.slug}/`}>
                            <div className="story-container">
                                <div className="img-hover-zoom">
                                  
                                    <GatsbyImage image={edge.node.featuredImage.gatsbyImageData} alt={edge.node.title} />
                                   
                                </div>
                                <div className="story-info">
                                    <span>POSTED IN {edge.node.category} - {edge.node.publishedDate}</span>
                                    <h3>{edge.node.title}</h3>
                                    <p>{edge.node.standfirst.childMarkdownRemark.excerpt}</p>
                                    <Button to={`/news/${edge.node.slug}/`}>
                                        Read more...
                                    </Button>
                                </div>
                            </div>
                        </Link>
                    </Story>
                ))}
                </StoryList>
                <PlanVisit />
            </ThreeQuarter>
        </React.Fragment>
    )
  }
}

export default BlogItems